import React from 'react';
import FieldTypesEnum from '../../../Enums/FieldTypesEnum';
import TabListTableCellWidthEnum from '../../../Enums/TabListTableCellWidthEnum';
import JsxHelper from '../../../Helpers/JsxHelper';
import Comments from '../../../Elements/Comments';
import LookupText from '../../../Elements/LookupText';
import LookupTextArray from '../../../Elements/LookupTextArray';
import AttachmentsComponent from '../../../Elements/AttachmentsComponent';
import dateTimeHelper from '../../../Helpers/datetimeHelper';
import FigmaBadge from '../../../Elements/FigmaBadge';
import DataTableActionMenu from '../../../Elements/DataTable/DataTableActionMenu';
import FraudHitEvaluatorTab from '../../Operations/AntiFraudTool/FraudHitEvaluatorTab';

export default class EvaluatorItem {
  constructor(item) {
    if (item === undefined) {
      this.EvId = '';
      this.EvUserId = '';
      this.EvSassieId = '';
      this.EvSsn = '';
      this.EvSassieLocationId = '';
      this.EvLastName = '';
      this.EvFirstName = '';
      this.EvPrefix = '';
      this.EvEmail = '';
      this.EvAddress = '';
      this.EvAddress2 = '';
      this.EvCity = '';
      this.EvState = '';
      this.EvCountry = '';
      this.EvZipCode = '';
      this.EvAreaCodes = '';
      this.SassiePpacceptedOn = '';
      this.LastTransferToTipalti = '';
      this.Emailchanged = 'false';
      this.TipaltiAccountStatus = '';
      this.TipaltiPaymentMethod = '';
      this.TipaltiPayableStatus = '';

      this.TipaltiPortalUser = '';
      this.TipaliAttemptedPassOver = '';
      this.TipaltiLastDataCheck = '';
      this.EvVat = '';
      this.EvIsAgency = '';
      this.EvInternational = '';
      this.EvRating = '';
      this.EvPaymentOfficeId = '';
      this.EvInactive = '';
      this.EvaluatorExtendedEvexSex = '';
      this.EvEmailoptout = '';
      this.EvFraudGroup = '';
      this.EvStatus = '';
      this.EvPaymentOfficeName = '';
      this.EvPaymentCurrency = '';
      this.MspacertificationLmcDesc = '';
      this.EvTransactionMethod = '';
      this.EvPaymentOfficeOverride = '';
      this.EvPaymentMethod = '';
      this.EvBday = '';
      this.EvPhoneNumber1 = '';
      this.EvPhoneNumber2 = '';
      this.EvLastShop = '';
      this.EvLngid = '';
      this.EvFraudGroupModifiedOn = '';
      this.EvFraudGroupModifiedBy = '';
      this.EvVatexp = '';
      this.EvVatType = false;
      this.EvSignDate = '';
      this.EvBank = '';
      this.EvBankAcct = '';
      this.EvPaypalAddress = '';
      this.EvIfsccode = '';
      this.EvSwiftCode = '';
      this.EvIban = '';
      this.EvSortCode = '';
      this.EvAccountType = '';
      this.EvDdpverify = '';
      this.TipaltiPaymentMethod = '';
      this.EvBankBranch = '';
      this.EvBankAddress = '';
      this.EvBankNum = '';
      this.EvBankZip = '';
      this.EvBankCity = '';
      this.EvBankCountry = '';
      this.EvBankroute = '';
      this.EvBrAccountType = '';
      this.EvBrBrbankBranchNum = '';
      this.EvBrBrbankAcctNum = '';
      this.EvCnAliPay = '';
      this.EvBankAccountHoldersName = '';
      this.EvBrBankCode = '';
      this.EvBrPis = '';
      this.EvBrCpf = '';
      this.EvFieldworkOfficeName = '';
      this.EvFieldworkOfficeId = '';
      this.EvCountryEvaluatorOfficeName = '';
      this.EvLmcid = '';
      this.EvClRutNumber = '';
      this.CountryName = '';
      this.ApolloLanguageName = '';
      this.EvBrBankCodeText = '';
      this.EvBrAccountTypeText = '';
      this.EvWiseEmail = '';
      this.EvWiseCurr = '';
      this.EvSgPayNow = '';
      this.EvBrPix = '';
      this.EvSsnStatus = '';
      this.EvaluatorExtendedEvexLangSpoken = '';
      this.EvaluatorExtendedEvexLangSpokenOther = '';
      this.EvaluatorExtendedEvexCitizenship = '';
      this.EvaluatorExtendedEvexRegBusiness = '';
      this.EvaluatorExtendedEvexBrBusinessClassification = '';
      this.EvaluatorExtendedEvexVehicle = '';
      this.EvaluatorExtendedEvexVehicleBrand = '';
      this.EvaluatorExtendedEvexPrimcarBrandOther = '';
      this.EvaluatorExtendedEvexTablet = '';
      this.EvaluatorExtendedEvexShopAbroad1 = '';
      this.EvInactiveFormatted = '';
      this.EvaluatorExtendedEvexTextAllow = '';
      this.EvLastlogin = '';
      this.EvLastRating = '';
      this.AllShopsCountLastNDays = 0;
      this.ExcludedShopsCountLastNDays = 0;
      this.FinalizedLockedShopsCountLastNDays = 0;
      this.ReferralClientShopsCountLastNDays = 0;
      this.EvEmailVerified = '';
      this.EvEmailVerifiedYN = '';
      this.EvPhoneNumber2OnlyNumbers = '';
      this.CombinedRating = '';
      this.ChinaIdCardNumber = '';
      this.TipaltiId = '';
      return;
    }
    this.EvId = item.evId;
    this.EvUserId = item.evUserId;
    this.EvSassieId = item.evSassieId;
    this.EvSsn = item.evSsn;
    this.EvSassieLocationId = item.evSassieLocationId;
    this.EvLastName = item.evLastName;
    this.EvFirstName = item.evFirstName;
    this.EvPrefix = item.evPrefix;
    this.EvEmail = item.evEmail;
    this.EvAddress = item.evAddress;
    this.EvAddress2 = item.evAddress2;
    this.EvCity = item.evCity;
    this.EvState = item.evState;
    this.EvCountry = item.evCountry;
    this.EvZipCode = item.evZipCode;
    this.EvAreaCodes = item.evAreaCodes;
    this.SassiePpacceptedOn = item.sassiePpacceptedOn;
    this.LastTransferToTipalti = item.lastTransferToTipalti;
    this.Emailchanged = item.emailChanged;
    this.TipaltiAccountStatus = item.tipaltiAccountStatus;
    this.TipaltiPaymentMethod = item.tipaltiPaymentMethod;
    this.TipaltiPayableStatus = item.tipaltiPayableStatus;
    this.EvLmcid = item.evLmcid;

    this.TipaltiPortalUser = item.tipaltiPortalUser;
    this.TipaliAttemptedPassOver = item.tipaliAttemptedPassOver;
    this.TipaltiLastDataCheck = item.tipaltiLastDataCheck;
    this.EvVat = item.evVat;
    this.EvIsAgency = item.evIsAgency;
    this.EvInternational = item.evInternational;
    this.EvRating = item.evRating;
    this.EvPaymentOfficeId = item.evPaymentOfficeId;
    this.EvInactive = item.evInactive;
    this.EvaluatorExtendedEvexSex = item.evaluatorExtendedEvexSex;
    this.EvEmailoptout = item.evEmailoptout;
    this.EvFraudGroup = item.evFraudGroup;
    this.EvStatus = item.evStatus;
    this.EvPaymentOfficeName = item.evPaymentOfficeName;
    this.EvPaymentCurrency = item.evPaymentCurrency;
    this.MspacertificationLmcDesc = item.mspacertificationLmcDesc;
    this.EvTransactionMethod = item.evTransactionMethod;
    this.EvPaymentMethod = this.calculatePaymentMethod(item.evPaymentMethod);
    this.EvBday = item.evBday;
    this.EvPhoneNumber1 = item.evPhoneNumber1;
    this.EvPhoneNumber2 = item.evPhoneNumber2;
    this.EvLastShop = item.evLastShop;
    this.EvPaymentOfficeOverride = item.evPaymentOfficeOverride;
    this.EvLngid = item.evLngid;
    this.EvFraudGroupModifiedOn = item.evFraudGroupModifiedOn;
    this.EvFraudGroupModifiedBy = item.evFraudGroupModifiedBy;
    this.EvVatexp = item.evVatexp;
    this.EvVatType = this.calculateEvVatType(item);
    this.EvSignDate = item.evSignDate;

    this.EvBank = item.evBank;
    this.EvBankAcct = item.evBankAcct;
    this.EvPaypalAddress = item.evPaypalAddress;
    this.EvIfsccode = item.evIfsccode;
    this.EvSwiftCode = item.evSwiftCode;
    this.EvIban = item.evIban;
    this.EvSortCode = item.evSortCode;
    this.EvAccountType = this.calculateAccountType(item.evAccountType);
    this.EvDdpverify = item.evDdpverify;
    this.EvBankBranch = item.evBankBranch;
    this.EvBankAddress = item.evBankAddress;
    this.EvBankNum = item.evBankNum;
    this.EvBankZip = item.evBankZip;
    this.EvBankCity = item.evBankCity;
    this.EvBankCountry = item.evBankCountry;
    this.EvBankroute = item.evBankroute;
    this.EvBrAccountType = item.evBrAccountType;
    this.EvBrBrbankBranchNum = item.evBrBrbankBranchNum;
    this.EvBrBrbankAcctNum = item.evBrBrbankAcctNum;
    this.EvCnAliPay = item.evCnAliPay;
    this.EvBankAccountHoldersName = item.evBankAccountHoldersName;
    this.EvBrBankCode = item.evBrBankCode;
    this.EvBrPis = item.evBrPis;
    this.EvBrCpf = item.evBrCpf;
    this.EvFieldworkOfficeName = item.evFieldworkOfficeName;
    this.EvFieldworkOfficeId = item.evFieldworkOfficeId;
    this.EvCountryEvaluatorOfficeName = item.evCountryEvaluatorOfficeName;
    this.EvFraudGroupModifiedByUserName = item.evFraudGroupModifiedByUserName;
    this.EvDdpMessage = item.evDdpMessage;
    this.EvClRutNumber = item.evClRutNumber;
    this.CountryName = item.countryName;
    this.ApolloLanguageName = item.apolloLanguageName;
    this.EvBrBankCodeText = item.evBrBankCodeText;
    this.EvBrAccountTypeText = item.evBrAccountTypeText;
    this.EvWiseEmail = item.evWiseEmail;
    this.EvWiseCurr = item.evWiseCurr;
    this.EvSgPayNow = item.evSgPayNow;
    this.EvBrPix = item.evBrPix;
    this.EvSsnStatus = item.evSsnStatus;
    this.EvaluatorExtendedEvexLangSpoken = item.evaluatorExtendedEvexLangSpoken;
    this.EvaluatorExtendedEvexLangSpokenOther = item.evaluatorExtendedEvexLangSpokenOther;
    this.EvaluatorExtendedEvexCitizenship = item.evaluatorExtendedEvexCitizenship;
    this.EvaluatorExtendedEvexRegBusiness = item.evaluatorExtendedEvexRegBusiness;
    this.EvaluatorExtendedEvexBrBusinessClassification = item.evaluatorExtendedEvexBrBusinessClassification;
    this.EvaluatorExtendedEvexVehicle = item.evaluatorExtendedEvexVehicle;
    this.EvaluatorExtendedEvexVehicleBrand = item.evaluatorExtendedEvexVehicleBrand;
    this.EvaluatorExtendedEvexPrimcarBrandOther = item.evaluatorExtendedEvexPrimcarBrandOther;
    this.EvaluatorExtendedEvexTablet = item.evaluatorExtendedEvexTablet;
    this.EvaluatorExtendedEvexShopAbroad1 = item.evaluatorExtendedEvexShopAbroad1;
    this.EvInactiveFormatted =
      item.evInactive === '1900-01-01T00:00:00' ? '' : dateTimeHelper.toYYYYsMMsDDWithIndefinite(item.evInactive);
    this.EvaluatorExtendedEvexTextAllow = item.evaluatorExtendedEvexTextAllow;
    this.EvLastlogin = item.evLastlogin;
    this.EvLastRating = item.evLastRating;
    this.EvEmailoptoutYN = item.evEmailoptout === true ? 'Y' : item.evEmailoptout === false ? 'N' : '';
    this.AllShopsCountLastNDays = item.allShopsCountLastNDays;
    this.ExcludedShopsCountLastNDays = item.excludedShopsCountLastNDays;
    this.FinalizedLockedShopsCountLastNDays = item.finalizedLockedShopsCountLastNDays;
    this.ReferralClientShopsCountLastNDays = item.referralClientShopsCountLastNDays;
    this.EvEmailVerified = item.evEmailVerified;
    this.EvEmailVerifiedYN = item.evEmailVerified === true ? 'Y' : item.evEmailVerified === false ? 'N' : '';
    this.ExcludedPSShopsCountLastNDays = item.excludedPSShopsCountLastNDays;
    this.EvPhoneNumber2OnlyNumbers = item.evPhoneNumber2OnlyNumbers;
    this.CombinedRating = `${item.evRating} (${item.evLastRating})`;
    this.ChinaIdCardNumber = item.chinaIdCardNumber;
    this.TipaltiId = item.tipaltiId;
  }

  calculateMSPACertification(EvLmcid) {
    switch (EvLmcid) {
      case '1':
        return 'Silver';
      case '2':
        return 'None';
      default:
        break;
    }
    return EvLmcid;
  }

  calculateAccountType(evAccountType) {
    switch (evAccountType) {
      case 'C':
        return 'Checking';
      case 'S':
        return 'Savings';
      default:
        break;
    }
    return evAccountType;
  }

  calculatePaymentMethod(paymentMethod) {
    switch (paymentMethod) {
      case 'I':
        return 'International';
      case 'D':
        return 'Direct Deposit';
      case 'C':
        return 'Check';
      case 'T':
        return 'Tipalti';
      default:
        break;
    }
    return paymentMethod;
  }

  calculateEvVatType(item) {
    if (!item.evVatexp && !item.evVat) return 'No VAT';
    if (!item.evVatexp && item.evVat) return 'Fee Only';
    return 'Fee and Expenses';
  }

  static NameOfTheIdField() {
    return 'EvId';
  }
  static nameOfTheItemDetailList() {
    return 'Evaluator';
  }

  static MoneyFields = [];

  static Currency() {
    return 'USD';
  }

  static MoneyFieldsSecondary = [];

  static CurrencySecondary() {
    return 'USD';
  }

  static DateFields = [
    'SassiePpacceptedOn',
    'TipaltiLastDataCheck',
    'EvBday',
    'EvLastShop',
    'EvInactive',
    'EvFraudGroupModifiedOn',
    'EvSignDate',
    'EvLastlogin',
    'EvSignDate',
  ];

  static BoolFields = [
    'Emailchanged',
    'EvInternational',
    'EvEmailoptout',
    'EvIsAgency',
    'EvVat',
    'EvVatexp',
    'EvPaymentOfficeOverride',
    'EvDdpverify',
    'TipaltiPayableStatus',
    'EvaluatorExtendedEvexVehicle',
  ];

  static editFunction = (id, user, userList) => {
    alert('Edit function');
  };

  static forceUploadToTpInstanceFunction = (id, user, userList) => {
    alert('Force upload to TP instance function');
  };

  static tipaltiEditReviewFunction = (id, user, userList) => {
    alert('TipaltiEditReview');
  };

  static evaluatorPaymentFunction = (id, user, userList) => {
    alert('Empty function');
  };

  static assigmentsFunction = (id, user, userList) => {
    alert('Empty function');
  };

  static attachementsFunction = (id, user, userList) => {
    alert('Empty function');
  };

  static FieldsToShowInListTable = [
    {
      tabName: 'General',
      tabLabel: 'General',
      icon: 'fa-solid fa-home',
      rolekey: 'Evaulator_tablisttable_EvaluatorGeneralView',
      data: [
        { name: 'EvSassieId', label: 'Apollo Id' },
        { name: 'EvPaymentMethod', label: 'Payment Method' },
        {
          name: (item) => EvaluatorItem.getTextAllowedValue(item),
          label: 'Text Message Authorized?',
          className: 'text-center',
        },
        { name: 'EvStatus', label: 'Evaluator Status' },
        { name: 'EvTransactionMethod', label: 'Transaction method' },
        {
          name: (item) => JsxHelper.YesNo(item.EvPaymentOfficeOverride),
          label: 'Override Evaluator Payment Office',
          className: 'text-center',
        },
        { name: 'EvFirstName', label: 'First Name' },
        { name: 'EvVatType', label: 'Apply VAT?' },
        {
          name: (item) => JsxHelper.YesNo(item.EvEmailoptout),
          label: 'Opted out from emails?',
          className: 'text-center',
        },
        { name: 'EvLastName', label: 'Last Name' },
        { name: 'EvPaymentCurrency', label: 'Payment Currency' },
        { name: (item) => JsxHelper.YesNo(item.EvIsAgency), label: 'Agency?', className: 'text-center' },
        { name: (item) => JsxHelper.MailTo(item.EvEmail), label: 'E-mail' },
        { name: 'EvPaymentOfficeName', label: 'Evaluator Payment Office' },
        { name: (item) => JsxHelper.YesNo(item.EvInternational), label: 'International?', className: 'text-center' },
        { name: 'EvRating', label: 'Apollo Rating' },
        { name: 'EvFieldworkOfficeName', label: 'Evaluator Fieldwork Office' },
        { name: 'SassiePpacceptedOn', label: 'Evaluator Privacy Policy Accepted On' },
        //	{name:"EvInactive", label:"Inactive Date"},
      ],
    },
    {
      tabName: 'Address',
      tabLabel: 'Address',
      icon: 'fa-solid fa-location-arrow',
      rolekey: 'Evaulator_tablisttable_EvaluatorGeneralView',
      data: [
        { name: 'EvAddress', label: 'Address 1' },
        { name: 'EvState', label: 'State' },
        { name: 'CountryName', label: 'Country Name' },
        { name: 'EvAddress2', label: 'Address 2' },
        { name: 'EvZipCode', label: 'Zip Code' },
        { name: 'EvPhoneNumber1', label: 'Phone 1' },
        { name: 'EvCity', label: 'City' },
        { name: 'EvCountry', label: 'Country' },
        { name: 'EvPhoneNumber2', label: 'Phone 2' },
      ],
    },
    {
      tabName: 'AdditionalInformation',
      tabLabel: 'Additional Information',
      rolekey: 'Evaulator_tablisttable_EvaluatorGeneralView',
      icon: 'fa-solid fa-plus-circle',
      data: [
        { name: 'EvSignDate', label: 'Signup Date' },
        { name: 'ApolloLanguageName', label: 'Apollo Language' },
        { name: 'EvSsn', label: 'SSN' },
        { name: 'EvBday', label: 'Date of Birth' },
        { name: 'EvaluatorExtendedEvexSex', label: 'Gender' },
        { name: 'EvSsnStatus', label: 'SSN Status' },
        { name: 'EvLastShop', label: 'Most Recent Shop Date' },
        { name: 'EvInactiveFormatted', label: 'Inactive Date' },
        { name: 'MspacertificationLmcDesc', label: 'MSPA Certification' },
      ],
    },
    {
      tabName: 'FraudInformation',
      tabLabel: 'Fraud Information',
      icon: 'fa-solid fa-user-slash',
      rolekey: 'Evaulator_tablisttable_EvaluatorFraudView',
      data: [{ name: EvaluatorItem.getFraudHitsContent, label: 'Fraud Hits', width: TabListTableCellWidthEnum.Table }],
    },
    {
      tabName: 'PaymentInformation',
      tabLabel: 'Payment Information',
      icon: 'fa-solid fa-money-check-alt',
      rolekey: 'Evaulator_tablisttable_EvaluatorPaymentDetailsView',
      data: [
        { name: 'EvBank', label: 'Bank Name' },
        { name: 'EvBankroute', label: 'Routing' },
        { name: 'EvPaypalAddress', label: 'Paypal Address' },
        { name: 'EvBankAccountHoldersName', label: 'Bank Account Holders Name' },
        { name: 'EvBankAcct', label: 'Account' },
        { name: 'EvIfsccode', label: 'IFSC Code (India only)' },
        { name: 'EvSwiftCode', label: 'Swift Code' },
        { name: 'EvIban', label: 'IBAN' },
        { name: 'EvSortCode', label: 'Sort Code' },
        { name: 'EvAccountType', label: 'Account Type' },
        { name: 'EvDdpverify', label: 'DDP Verified' },
        { name: 'EvDdpMessage', label: 'DDP Message' },
        { name: 'TipaltiPortalUser', label: 'Tipalti Account' },
        { name: 'TipaltiPayableStatus', label: 'Tipalti Payable Status' },
        { name: 'TipaltiPaymentMethod', label: 'Tipalti Payment Method' },
      ],
    },
    {
      tabName: 'BankInformation',
      tabLabel: 'Bank Information',
      icon: 'fa-solid fa-university',
      rolekey: 'Evaulator_tablisttable_EvaluatorPaymentDetailsView',
      data: [
        { name: 'EvBankBranch', label: 'Bank Branch' },
        { name: 'EvBrBrbankBranchNum', label: 'BR Bank Branch Number' },
        { name: 'EvCnAliPay', label: 'AliPay ID' },
        { name: 'EvBankNum', label: 'Bank Number' },
        { name: 'EvBrBankCodeText', label: 'BR Bank Code' },
        { name: 'EvSgPayNow', label: 'SG Paynow' },
        { name: 'EvBankAddress', label: 'Bank Address' },
        { name: 'EvBrBrbankAcctNum', label: 'BR Bank Account Number' },
        { name: 'EvClRutNumber', label: 'RUT#' },
        { name: 'EvBankZip', label: 'Bank ZIP' },
        { name: 'EvBrPis', label: 'BR PIS' },
        { name: 'EvWiseEmail', label: 'Wise Account Email' },
        { name: 'EvBankCity', label: 'Bank City' },
        { name: 'EvBrAccountTypeText', label: 'BR Account Type' },
        {
          name: (item) => (
            <LookupText
              lookupId={100}
              value={item.EvWiseCurr}
            />
          ),
          label: 'Wise Currency',
        },
        { name: 'EvBankCountry', label: 'Bank Country' },
        { name: 'EvBrCpf', label: 'BR CPF' },
        { name: '', label: '' },
        { name: '', label: '' },
        { name: 'EvBrPix', label: 'BR PIX' },
      ],
    },
    {
      tabName: 'ESP',
      tabLabel: 'ESP',
      icon: 'fa-solid fa-user-plus',
      rolekey: 'Evaulator_tablisttable_EvaluatorESPView',
      data: [
        {
          name: (item) => (
            <LookupTextArray
              lookupId={98}
              valueArray={item.EvaluatorExtendedEvexLangSpoken}
            />
          ),
          label: 'Languages Fluent in',
          tooltipText: 'Select all the languages you are fluent in and are capable of performing evaluations in.',
        },
        {
          name: (item) => JsxHelper.YesNoEmpty(item.EvaluatorExtendedEvexVehicle, 1, 2),
          label: 'Owns a Vehicle',
          tooltipText:
            'Do you own a motorized vehicle? (Please note this ALSO refers to 2-wheelers, scooters and any other motorized vehicle.)',
        },
        {
          name: (item) => JsxHelper.YesNoEmpty(item.EvaluatorExtendedEvexRegBusiness, 1, 2),
          label: 'Owns a Registered Business',
          tooltipText: 'Do you own a registered business?',
        },
        {
          name: 'EvaluatorExtendedEvexLangSpokenOther',
          label: 'Other Languages',
          tooltipText: ',,If other, please enter it here.',
        },
        {
          name: (item) => (
            <LookupText
              lookupId={102}
              value={item.EvaluatorExtendedEvexVehicleBrand}
            />
          ),
          label: 'Vehicle Type',
          tooltipText: 'If you own a motorized vehicle, what brand/make is it?',
        },
        {
          name: (item) => (
            <LookupText
              lookupId={99}
              value={item.EvaluatorExtendedEvexBrBusinessClassification}
            />
          ),
          label: 'Business Classification',
          tooltipText: 'If you own a registered business, what is the classification of your business?',
        },
        {
          name: (item) => (
            <LookupText
              lookupId={101}
              value={item.EvaluatorExtendedEvexCitizenship}
            />
          ),
          label: 'Citizenship',
          tooltipText: 'What is your citizenship?',
        },
        {
          name: 'EvaluatorExtendedEvexPrimcarBrandOther',
          label: 'Vehicle Type Other',
          tooltipText: 'If other, please enter it here.',
        },
        {
          name: (item) => JsxHelper.YesNoEmpty(item.EvaluatorExtendedEvexTablet, 1, 2),
          label: 'Owns a Tablet',
          tooltipText: 'Do you own a tablet you can use for evaluations?',
        },
        {
          name: 'ChinaIdCardNumber',
          label: 'Citizen ID Card Number',
        },
        { name: '-message-', label: '' },
        {
          name: 'EvaluatorExtendedEvexShopAbroad1',
          label: 'Travels regularly',
          width: TabListTableCellWidthEnum.TwoLines,
          tooltipText:
            'If you travel regularly to any other area than the one listed as your primary address where you would be interested in completing evaluations, please list the country, state, postal code and/or area code. (For example: US, Virginia, 20120. Please separate each with a comma.)',
        },
      ],
    },
    {
      tabName: 'Comments',
      tabLabel: 'Comments',
      icon: 'fa-solid fa-comment',
      rolekey: 'Evaulator_tablisttable_EvaluatorGeneralView',
      data: [
        { name: EvaluatorItem.getCommentsContent, label: 'Comments', width: TabListTableCellWidthEnum.TwoLines },
        { name: '-message-', label: 'The comments above are related to the primary user.' },
      ],
    },
    {
      tabName: 'Attachments',
      tabLabel: 'Attachments',
      icon: 'fa-solid fa-paperclip',
      rolekey: 'Evaulator_tablisttable_EvaluatorGeneralView',
      data: [
        { name: EvaluatorItem.getAttachmentsContent, label: 'Attachments', width: TabListTableCellWidthEnum.TwoLines },
      ],
    },
  ];

  static getTextAllowedValue(item) {
    return item.EvaluatorExtendedEvexTextAllow === 'Yes' || item.EvaluatorExtendedEvexTextAllow === 'No'
      ? JsxHelper.YesNo(item.EvaluatorExtendedEvexTextAllow === 'Yes')
      : item.EvaluatorExtendedEvexTextAllow;
  }

  static getAttachmentsContent(item) {
    return (
      <AttachmentsComponent
        entityTypeId={27}
        entityId={item.FreelancerUserId}
        enableAddNew={true}
      />
    );
  }

  //Meaning of data field:
  //   if type is FieldTypesEnum.DataFieldWithDetails then it is the name of the ID field
  //   if type is FieldTypesEnum.PureDataField then it is the name of the field to show
  //   if type is FieldTypesEnum.FunctionField then it is the function
  //   In the following example the FreelancerUserItem.editFunction function is a static variable in this class, so you can change its value
  //   I change the value in the constructor of the FreelancerUserAdmin component
  static getIsActiveCellContent(item) {
    return (
      <div className='pointer'>
        {
          <FigmaBadge
            Active={item.EvIsAgency}
            ActiveText='Yes'
            InactiveText='No'
            width={50}
          />
        }
      </div>
    );
  }
  static FieldsToShowInDataTable() {
    return [
      { label: 'Caspian Id', orderById: 'EvId', data: 'EvId', type: FieldTypesEnum.DataFieldWithDetails },
      { label: 'Apollo Id', orderById: 'EvSassieId', data: 'EvSassieId', minWidth: '100px' },
      { label: 'Name', orderById: 'LastName', data: (item) => `${item.EvFirstName} ${item.EvLastName}` },
      { label: 'Email', orderById: 'EvEmail', data: (item) => JsxHelper.MailTo(item.EvEmail, 40) },
      { label: 'Evaluator Status', orderById: 'EvStatus', data: 'EvStatus', minWidth: '120px' },
      { label: 'Agency?', orderById: 'EvIsAgency', data: EvaluatorItem.getIsActiveCellContent, minWidth: 50 },
      {
        label: 'Address',
        orderById: 'EvZipCode',
        data: (item) => `${item.EvAddress} ${item.EvAddress2} ${item.EvCity} ${item.EvZipCode} ${item.EvState}`,
      },
      { label: 'Country', orderById: 'EvCountry', data: 'CountryName' },
      { label: 'Fraud Group', orderById: 'EvFraudGroup', data: 'EvFraudGroup' },
      {
        label: ' ',
        orderById: 'EvFraudGroup',
        data: EvaluatorItem.getActionsContent,
        type: FieldTypesEnum.ActionButton,
      },
    ];
  }

  static getActionsContent(item) {
    return (
      <DataTableActionMenu
        options={[
          {
            iconName: 'fa-solid fa-edit',
            roleKey: 'Evaulator_faicon_Edit',
            text: 'Edit',
            onClick: () => EvaluatorItem.editFunction(item.EvaluatorId, item),
          },
          {
            iconName: 'fa-solid fa-user-circle',
            roleKey: 'Evaulator_faicon_EvaluatorTipaltiProfileButton',
            text: 'Tipalti Profile',
            onClick: () => EvaluatorItem.tipaltiEditReviewFunction(item.EvaluatorId, item),
          },
          {
            iconName: 'fa-solid fa-money-check-alt',
            roleKey: 'Evaulator_faicon_EvaluatorPaymentsButton',
            text: 'Evaluator Payment',
            onClick: () => EvaluatorItem.evaluatorPaymentsFunction(item),
          },
          {
            iconName: 'fa-solid fa-tasks',
            roleKey: 'Evaulator_faicon_AssignmentsButton',
            text: 'Assignments',
            onClick: () => EvaluatorItem.assigmentsFunction(item.EvaluatorId, item),
          },
          {
            iconName: 'fa-solid fa-cloud-upload',
            roleKey: 'justForAdmins',
            text: 'Force Upload to TP Instance',
            onClick: () => EvaluatorItem.forceUploadToTpInstanceFunction(item.EvaluatorId, item),
          },
        ]}
      />
    );
  }

  static getCommentsContent(item) {
    return (
      <Comments
        entityTypeId={27}
        entityId={item.EvId}
      />
    );
  }

  static getFraudHitsContent(item) {
    return (
      <FraudHitEvaluatorTab
        evaluatorId={item.EvId}
        selectedFraudStatuses={[]} // Show every fraud status on the evaluator details view
      />
    );
  }

  static CreateEditedEvaluatorJSONObject(editedEvaluator) {
    const evJson = {
      EvId: editedEvaluator.EvId.toString(),
      EvPaymentMethod: editedEvaluator.EvPaymentMethod,
      EvVatType: editedEvaluator.EvVatType,
      TransactionMethod: editedEvaluator.EvTransactionMethod ? editedEvaluator.EvTransactionMethod : '',
      EvIsAgency: editedEvaluator.EvIsAgency.toString(),
    };
    return JSON.stringify(evJson);
  }
}
